/**
 * Memory Admin Page (Employee-only)
 *
 * Admin view for memory module management across tenants.
 * Shows configuration parameters, cost projections, and tenant configs.
 */
import { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@personic/shared'
import { Brain, DollarSign, Settings } from 'lucide-react'
import { MemoryAdminConfig } from './MemoryAdminConfig'
import { MemoryAdminCosts } from './MemoryAdminCosts'

export default function MemoryAdmin() {
  const [activeTab, setActiveTab] = useState('config')

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Brain className="h-8 w-8 text-purple-400" />
        <div>
          <h1 className="text-2xl font-bold text-white">Memory Administration</h1>
          <p className="text-sm text-neutral-400">
            Manage memory module configuration and monitor costs
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="config" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Parameters
          </TabsTrigger>
          <TabsTrigger value="costs" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Cost Projections
          </TabsTrigger>
        </TabsList>

        <TabsContent value="config">
          <MemoryAdminConfig />
        </TabsContent>

        <TabsContent value="costs">
          <MemoryAdminCosts />
        </TabsContent>
      </Tabs>
    </div>
  )
}
